import api from './api'
import { TenantAdmin, TenantRequest } from '@/types/tenant'

const BASE_URL = '/api/v1/tenants'

// O interceptor de `api` já devolve o body — retornamos `response` diretamente.
export const tenantService = {
  listar: async (): Promise<TenantAdmin[]> => {
    return api.get<TenantAdmin[]>(BASE_URL) as unknown as Promise<TenantAdmin[]>
  },
  obter: async (id: string): Promise<TenantAdmin> => {
    return api.get<TenantAdmin>(`${BASE_URL}/${id}`) as unknown as Promise<TenantAdmin>
  },
  criar: async (request: TenantRequest): Promise<TenantAdmin> => {
    return api.post<TenantAdmin>(BASE_URL, request) as unknown as Promise<TenantAdmin>
  },
  atualizar: async (id: string, request: TenantRequest): Promise<TenantAdmin> => {
    return api.put<TenantAdmin>(`${BASE_URL}/${id}`, request) as unknown as Promise<TenantAdmin>
  },
  desativar: async (id: string): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`)
  },
}
